import React, { useEffect } from 'react';
import { AlerteMi } from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';

const AlerteAutoClosed = ({ titre, type, description, onClose, autoClose = true }) => {
    useEffect(() => {
        if (autoClose) {
            setTimeout(onClose, process.env.REACT_APP_ALERT_TIMEOUT);
        }
    }, []);
    return <AlerteMi titre={titre} type={type} description={description} onClose={onClose} />;
};

AlerteAutoClosed.propTypes = {
    titre: PropTypes.string,
    type: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onClose: PropTypes.func.isRequired,
    autoClose: PropTypes.bool,
};

export default AlerteAutoClosed;
